import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ContextReasonPipe } from './context-reason.pipe';

@NgModule({
    declarations: [ContextReasonPipe],
    imports: [CommonModule, TranslateModule],
    providers: [ContextReasonPipe],
    exports: [ContextReasonPipe]
})
export class ContextReasonPipeModule {}

export { ContextReasonPipe };
